import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { AuthService } from '../services/auth.service';
import { BestellungenService } from '../../features/bestellungen/services/bestellungen.service';

export const posBestellungLockGuard: CanActivateFn = (route) => {
    const authService = inject(AuthService);
    const bestellungenService = inject(BestellungenService);
    const router = inject(Router);

    if (!authService.isPosSession()) {
        return true;
    }

    const bestellungId = route.paramMap.get('id');

    if (!bestellungId) {
        return router.createUrlTree(['/bestellungen']);
    }

    return bestellungenService.acquireBestellungLock(bestellungId).pipe(
        map(() => true),
        catchError(() => of(router.createUrlTree(['/bestellungen'])))
    );
};